import wrapHelper from './wrap-helper.js';

const postImgDiv = () => {
	document.querySelectorAll('.post-content-inner img').forEach(function (wrapImage) {
		if (wrapImage.classList.contains('not-responsive')) {

		} else {
			wrapHelper(wrapImage, document.createElement('div'));
		}
	});
}

export default postImgDiv;